import QuizSpot from "./QuizSpot";
import { Popup } from "../../../../Types";
import OpenTextPopup from "../../Hotspots/OpenTextPopup";
import OpenVideoPopup from "../../Hotspots/OpenVideoPopup";
import OpenImagePopup from "../../Hotspots/OpenImagePopup";
import { editorHotspotStore, useTourDataStore } from "../../../../api/Zustand";

function ExpHotspot() {
  const { tourData } = useTourDataStore();
  const { hotspot, openHotspot, hotspotData } = editorHotspotStore();

  return (
    <div
      className="exp-hotspot-wrapper"
      id={hotspot ? "open" : "closed"}
      onDoubleClick={() => openHotspot(false)}
    >
      <div className="exp-hotspot" id={hotspot ? "open" : "closed"}>
        {hotspotData ? (
          tourData?.popups.find((one: Popup) => one.id === hotspotData)
            ?.type === "text" ? (
            <OpenTextPopup
              popup={
                tourData?.popups.find((one: Popup) => one.id === hotspotData)!
              }
              setOpen={openHotspot}
            />
          ) : tourData?.popups.find((one: Popup) => one.id === hotspotData)
              ?.type === "video" ? (
            <OpenVideoPopup
              popup={
                tourData?.popups.find((one: Popup) => one.id === hotspotData)!
              }
              hotspot={hotspot}
              setOpen={openHotspot}
            />
          ) : tourData?.popups.find((one: Popup) => one.id === hotspotData)
              ?.type === "image" ? (
            <OpenImagePopup
              popup={
                tourData?.popups.find((one: Popup) => one.id === hotspotData)!
              }
              setOpen={openHotspot}
            />
          ) : (
            <QuizSpot
              hotspotData={parseInt(hotspotData)}
              tourData={tourData!}
              setOpen={openHotspot}
            />
          )
        ) : null}
      </div>
    </div>
  );
}

export default ExpHotspot;
